import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import SubHeader from '../../../../../component/common/layout/SubHeader'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import Svg from '../../../../../component/common/Svg';
import Switch from "../../../../../core/Switch";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useVerifySurveyId } from '../../../../../hooks';
import { getLeadGenVariable } from '../../../../../store/actions/variableAction';
import FormBuilderHeader from './components/FormBuilderHeader';
import CustomInput from './components/CustomInput';
import { getTokenData } from '../../../../../store/actions/authAction';
import { addField, changeOrder, deleteField, updateStaticField, uploadBannerImage } from '../../../../../store/actions/formBuilderAction';
import EditModal from './components/EditModal';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditTermAndConditionModal from './components/EditTermAndConditionModal';
import EditSubmitBtnModal from './components/EditSubmitBtnModal';
import CustomInputPreview from './components/CustomInputPreview';
import DeleteModal from './components/DeleteModal';
// import Input from "../../../../../core/Inputs/DefaultInput";
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import bannerFallbackImg from '../../../../../assets/images/lead-gen-form1.jpg';


export default function Index() {
    const { t } = useTranslation();
    //==> States <==
    const modes = {
        edit: 'EDIT',
        preview: 'VIEW'
    }

    const [mode, setMode] = useState(modes.edit)
    const [userId, setuserId] = useState('')
    const [isCheckedTandC, setIsCheckedTandC] = useState(false)

    //Modals
    const [modalOpen, setModalOpen] = useState(false)
    const [modalData, setModalData] = useState(null)
    const [currentlyDeletingField, setCurrentlyDeletingField] = useState(null)

    const [TandCModalOpen, setTandCModalOpen] = useState(false)
    const [TandCData, setTandCData] = useState(null)

    const [submitModalOpen, setSubmitModalOpen] = useState(false)
    const [submitData, setSubmitData] = useState(null)
    const [submitPosition, setSubmitPosition] = useState('start')

    const [heading, setHeading] = useState('')
    const [description, setDescription] = useState('')
    const [privacyHeading, setPrivacyHeading] = useState('')
    const [bannerPreview, setBannerPreview] = useState('')
    const [objectPreviewUrl, setObjectPreviewUrl] = useState('')
    let saveTimer = null


    let shape = {
        privacy_heading: Yup.string().required(t('survey.builder.privacyHeading')),
    }
    const formSchema = Yup.object().shape(shape)
    //Selector
    const { survey_name } = useSelector((state) => state.permissionsData)
    const { fieldData: leadGenData } = useSelector((state => state?.formBuilderData))
    let initialValues = {
        privacy_heading: ''
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema
    })
    // eslint-disable-next-line
    const { setFieldValue } = formik


    //Others
    const survey_id = useVerifySurveyId()
    const dispatch = useDispatch()
    const language_code = '22'
   

    //==> FUNCTIONALITIES <==

    //Data handling
    const handleChangeMode = (value) => {
        setMode(value)
    }

    const handleAddField = (type) => {
        const name = `name_${Math.floor(Math.random() * 1000)}`
        if (type === 'name' || type === 'text' || type === 'email' || type === 'number' || type === 'radio' || type === 'checkbox') {
            const fieldType = 1
            const option = { 0: { type: type, required: false, placeholder: t('survey.builder.place') } }
            let payload = {
                user: userId,
                survey_id: survey_id,
                language_code: language_code,
                label: t('survey.builder.label'),
                name: name,
                options: option,
                order: leadGenData?.length ? (leadGenData?.length === 0 ? 1 : leadGenData?.length) : 1,
                type: fieldType,
            }
            if (type === 'radio' || type === 'checkbox') {
                payload = {
                    ...payload, options: {
                        0: { type: type, value: t('survey.builder.option1'), required: false }, 1: { type: type, value: t('survey.builder.option2'), required: false }
                    }
                }
            }
            dispatch(addField(payload))
        } else if (type === 'textarea') {
            const fieldType = 4
            let payload = {
                user: userId,
                survey_id: survey_id,
                language_code: language_code,
                label: t('survey.builder.label'),
                name: name,
                options: { required: false, placeholder: t('survey.builder.place') },
                order: leadGenData?.length ?? 1,
                type: fieldType,
            }
            dispatch(addField(payload))
        } else if (type === 'dropdown') {
            const fieldType = 3
            let payload = {
                user: userId,
                survey_id: survey_id,
                language_code: language_code,
                label: t('survey.builder.label'),
                name: name,
                options: { option: { opt1: t('survey.builder.option1'), opt2: t('survey.builder.option2') }, required: false, placeholder: t('survey.builder.place') },
                order: leadGenData?.length ?? 1,
                type: fieldType,
            }
            dispatch(addField(payload))
        } else if (type === 'hidden') {
            const fieldType = 5
            let payload = {
                user: userId,
                survey_id: survey_id,
                language_code: language_code,
                label: t('survey.builder.label'),
                name: name,
                options: { 0: { type: type, required: false, placeholder: t('survey.builder.hidden'), defaultValue: '' } },
                order: leadGenData?.length ?? 1,
                type: fieldType,
            }
            dispatch(addField(payload))
        } else if (type === 'label') {
            const fieldType = 6
            let payload = {
                user: userId,
                survey_id: survey_id,
                language_code: language_code,
                label: t('survey.builder.labelField'),
                name: name,
                options: {},
                order: leadGenData?.length ?? 1,
                type: fieldType,
            }
            dispatch(addField(payload))
        }
    }

    const handleDeleteField = (id) => {
        const payload = {
            fieldId: id
        }
        dispatch(deleteField(payload))
        setCurrentlyDeletingField(null)
    }

    const handleChangeTandCRequired = (e, label) => {
        const checked = e.target.checked
        setIsCheckedTandC(checked)
        const payload = {
            language_code,
            label,
            name: 'TANDC',
            options: { required: checked },
            survey_id,
        }
        dispatch(updateStaticField(payload))
    }

    // legacy blur handler (no longer used for privacy)

    const savePrivacyHeadingHtml = (html) => {
        const payload = { language_code, label: html, name: 'PRIVACY', options: { options: null }, survey_id }
        dispatch(updateStaticField(payload))
        setPrivacyHeading(html)
    }

    const handlePrivacyChange = (e) => {
        const html = e.target.value
        setPrivacyHeading(html)
        if (saveTimer) clearTimeout(saveTimer)
        saveTimer = setTimeout(() => savePrivacyHeadingHtml(html), 600)
    }

  // Prefer the admin's Node API base URL, fall back to public API, then current origin
  const apiBaseUrl = (
    (process.env.REACT_APP_NODE_API_URL && process.env.REACT_APP_NODE_API_URL.replace(/\/$/, "")) ||
    (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.replace(/\/$/, "")) ||
    window.location.origin
  );

   

      const resolveBannerSrc = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    const cleaned = path.replace(/^\/+/, "");
    return `${apiBaseUrl}/frnt/file/${cleaned}`;
  };

    const handleBannerUpload = async (e) => {
        const file = e.target.files && e.target.files[0]
        if (!file) return
        // lightweight guard (5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error(t('survey.builder.bannerSizeError'))
            return
        }
        if (objectPreviewUrl) {
            URL.revokeObjectURL(objectPreviewUrl)
        }
        try {
            const objUrl = URL.createObjectURL(file)
            setObjectPreviewUrl(objUrl)
            setBannerPreview(objUrl)
        } catch (err) {
            setObjectPreviewUrl('')
        }
        const result = await dispatch(uploadBannerImage({ survey_id, language_code, file }))
        if (result?.success) {
            toast.success(t('survey.builder.bannerUploadSuccess'))
        } else {
            toast.error(t('survey.builder.bannerUploadFailed'))
        }
    }

    //React-beautiful-dnd
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    const onDragEnd = (result) => {
        if (window.modulePermissions.M12.edit != 1) {
            return;
        }
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        let oldOrder = leadGenData?.map((field) => field.su_lead_gen_variable_id)

        const fields = reorder(
            oldOrder,
            result.source.index,
            result.destination.index
        )

        let newOrder = {}
        fields?.forEach((field, index) => newOrder[field] = index + 1)
        const payload = {
            survey_id: survey_id,
            order: newOrder
        }
        dispatch(changeOrder(payload))
    }



    //==> EFFECTS <==
    useEffect(() => {
        if (survey_id) {
            dispatch(getLeadGenVariable(survey_id))
        }
    }, [survey_id, dispatch])

    useEffect(() => {
        if (survey_id) {
            dispatch(getTokenData(setuserId))
        }
    }, [userId, survey_id, dispatch])

    useEffect(() => {
        if (leadGenData) {
            let tandc = leadGenData.filter((field) => field.su_name === 'TANDC' && Number(field.su_form_variable_type) === 99)
            tandc = tandc ? tandc[0] : null
            setTandCData(tandc)

            let options = tandc?.su_options && JSON.parse(tandc.su_options)
            let required = options ? options.required : false
            setIsCheckedTandC(required)

            let submit = leadGenData.filter((field) => field.su_name === 'SUBMIT' && Number(field.su_form_variable_type) === 99)
            submit = submit ? submit[0] : null
            setSubmitData(submit)

            let pos = submit?.su_options && JSON.parse(submit.su_options)
            pos = pos ? pos.alignment : 'Left'
            pos = pos === 'Left' ? 'start' : pos === 'Right' ? 'end' : 'center'
            setSubmitPosition(pos)

            let heading = leadGenData.filter((field) => field.su_name === 'HEADING' && Number(field.su_form_variable_type) === 99)
            heading = heading ? heading[0] : null
            heading = heading?.su_label_and_options ? JSON.parse(heading?.su_label_and_options)[language_code] : ''
            setHeading(heading)

            let desc = leadGenData.filter((field) => field.su_name === 'DESC' && Number(field.su_form_variable_type) === 99)
            desc = desc ? desc[0] : null
            desc = desc?.su_label_and_options ? JSON.parse(desc?.su_label_and_options)[language_code] : ''
            setDescription(desc)

            let privacyHeadingItem = leadGenData.filter((field) => field.su_name === 'PRIVACY' && Number(field.su_form_variable_type) === 99)
            privacyHeadingItem = privacyHeadingItem ? privacyHeadingItem[0] : null
            const privacyHtml = privacyHeadingItem?.su_label_and_options && (JSON.parse(privacyHeadingItem?.su_label_and_options)[language_code] ?? '')
            setPrivacyHeading(privacyHtml || '')

            let bannerItem = leadGenData.filter((field) => field.su_name === 'BANNER' && Number(field.su_form_variable_type) === 99)
            bannerItem = bannerItem ? bannerItem[0] : null
            const banner = bannerItem?.su_label_and_options && (JSON.parse(bannerItem?.su_label_and_options)[language_code] ?? '')
            if (banner) {
                setBannerPreview(resolveBannerSrc(banner))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leadGenData])

    useEffect(() => () => {
        if (objectPreviewUrl) {
            URL.revokeObjectURL(objectPreviewUrl)
        }
    }, [objectPreviewUrl])



    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <SurveyListHeader />
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <SurveyListSidebar />
                    <div id="content" className="flex-grow-1 dashboard-page-outer">
                        <SubHeader />
                        <div className="survey-main-container">
                            <div className="page-heading">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.builder.title')}</strong></li>
                                    </ol>
                                </nav>
                                <h1>{t('survey.builder.title')}</h1>
                            </div>
                            <div className="survey-container">
                                <div className="form-preview-wrapper">
                                    <div className="switch-button d-inline-flex align-items-center">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="deletecheck-q1"
                                                id="form-preview-q1"
                                                checked={mode === modes.edit}
                                                onChange={() => handleChangeMode(modes.edit)}
                                            />
                                            <label className="form-check-label" htmlFor="form-preview-q1">
                                                {t('survey.builder.edit')}
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="deletecheck-q1"
                                                id="preview-view-q1"
                                                checked={mode === modes.preview}
                                                onChange={() => handleChangeMode(modes.preview)}
                                            />
                                            <label className="form-check-label" htmlFor="preview-view-q1">
                                                {t('survey.builder.preview')}
                                            </label>
                                        </div>
                                    </div>
                                    {/*Form Edit Version*/}
                                    {mode === modes.edit && <div className="form-wraper">
                                        <div className="form-inner">
                                            <FormBuilderHeader
                                                language_code={language_code}
                                                survey_id={survey_id}
                                                leadGenData={leadGenData}
                                            />

                                            <DragDropContext onDragEnd={onDragEnd}>
                                                <Droppable droppableId="LeadGenFieldsDragable">
                                                    {(provided, snapshot) => (
                                                        <div
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}
                                                        >
                                                            {
                                                                leadGenData?.map((field, index) => {
                                                                    if (Number(field.su_lead_gen_variable_id) !== 99) {
                                                                        return (
                                                                            <Draggable key={index} draggableId={`LeadGenFieldsDropable${index}`} index={index}>
                                                                                {(provided, snapshot) => (
                                                                                    <div
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                    >
                                                                                        < CustomInput
                                                                                            provided={provided}
                                                                                            data={field}
                                                                                            index={index}
                                                                                            modalOpen={modalOpen}
                                                                                            setModalOpen={setModalOpen}
                                                                                            setModalData={setModalData}
                                                                                            survey_id={survey_id}
                                                                                            language_code={language_code}
                                                                                            setCurrentlyDeletingField={setCurrentlyDeletingField}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        )
                                                                    }
                                                                    return null
                                                                })
                                                            }
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>

                                            {window.modulePermissions.M12.add == 1 && (<div className="btn-wrap add-field-option mb__20 dropdown ">
                                                <button className="add-option d-inline-flex align-items-center" type="button" id="languages" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <Svg name="add-option" /> {t('survey.builder.add')}
                                                </button>
                                                <div className="dropdown-menu option-dop" aria-labelledby="languages">
                                                    <span className="dropdown-item" onClick={() => handleAddField('text')}>{t('survey.builder.textfield')}</span>
                                                    {/* <span className="dropdown-item" onClick={() => handleAddField('name')}>Name field</span> */}
                                                    <span className="dropdown-item" onClick={() => handleAddField('textarea')}>{t('survey.builder.area')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('email')}>{t('survey.builder.email')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('dropdown')}>{t('survey.builder.drop')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('number')}>{t('survey.builder.num')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('checkbox')}>{t('survey.builder.check')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('radio')}>{t('survey.builder.radio')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('hidden')}>{t('survey.builder.hidden1')}</span>
                                                    <span className="dropdown-item" onClick={() => handleAddField('label')}>{t('survey.builder.labelField')}</span>
                                                </div>
                                            </div>)}

                                            <div className="form-field-wrapper d-flex mb__20">
                                                <div className="input-wrap flex-grow-1">
                                                    <div className="d-flex align-items-center">
                                                        <input className="form-check-input terms-check" name="terms-check" type="checkbox" id={`leadGenCheckbox_${survey_id}`} disabled={window.modulePermissions.M12.edit != 1} />
                                                        <lable htmlFor={`leadGenCheckbox_${survey_id}`} dangerouslySetInnerHTML={{ __html: TandCData?.su_label_and_options && (JSON.parse(TandCData.su_label_and_options)[language_code] ?? '') }} />
                                                    </div>
                                                </div>
                                                <div className="action-wrap d-flex align-items-center mt-0">
                                                    <div className="action-buttons d-flex align-items-center">
                                                        {/* <button className='action-btn draggable' title="Reorder">
                                                            <Svg name="draggable" />
                                                        </button> */}
                                                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title={t('survey.builder.edit1')} onClick={() => setTandCModalOpen(true)}>
                                                            <Svg name="edit" />
                                                        </button>}
                                                        {/* <button className='action-btn delete' title="Delete field">
                                                            <Svg name="section-delete" />
                                                        </button> */}
                                                    </div>
                                                    <div className="required-option d-flex align-items-center">
                                                        <div className="action-wrapper d-flex accordianSwitch">
                                                            < Switch
                                                                type='dense'
                                                                color='default'
                                                                disabled={window.modulePermissions.M12.edit != 1}
                                                                label={t('survey.builder.required')}
                                                                fill={false}
                                                                rtl={false}
                                                                leftPosition={false}
                                                                className='SwitchCustom'
                                                                checked={isCheckedTandC}
                                                                onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleChangeTandCRequired(e, TandCData?.su_label_and_options && (JSON.parse(TandCData.su_label_and_options)[language_code] ?? '')) : undefined}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-field-wrapper d-flex mb__20">
                                                <div className="input-wrap flex-grow-1 position-relative">
                                                    <label className="form-label-custom mb-2">{t('survey.builder.privacyHeading')}</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="3"
                                                        placeholder='<a href="https://www.example.com">Privacy policy</a>'
                                                        value={privacyHeading}
                                                        onChange={window.modulePermissions.M12.edit == 1 ? handlePrivacyChange : undefined}
                                                        onBlur={window.modulePermissions.M12.edit == 1 ? (e) => savePrivacyHeadingHtml(e.target.value) : undefined}
                                                        readOnly={window.modulePermissions.M12.edit != 1}
                                                    />
                                                </div>
                                                <div className="action-wrap action-mob"></div>
                                            </div>

                                            <div className="form-field-wrapper d-flex mb__20">
                                                <div className="input-wrap flex-grow-1 position-relative">
                                                    <label className="form-label-custom mb-2">{t('survey.builder.bannerImage')}</label>
                                                    <div className="d-flex align-items-center">
                                                        {bannerPreview ? (
                                                            <img
                                                                src={bannerPreview}
                                                                alt="banner"
                                                                style={{ width: '120px', height: '80px', objectFit: 'cover', borderRadius: '4px', marginRight: '12px' }}
                                                                onError={(e) => {
                                                                    // If the synced DB record points to a missing file (404),
                                                                    // show a static fallback so the user can upload a new one.
                                                                    if (bannerPreview !== bannerFallbackImg) {
                                                                        // prevent infinite onError loop
                                                                        if (e?.currentTarget) e.currentTarget.onerror = null;
                                                                        setBannerPreview(bannerFallbackImg);
                                                                    }
                                                                }}
                                                            />
                                                        ) : null}
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            className="form-control"
                                                            onChange={handleBannerUpload}
                                                            disabled={window.modulePermissions.M12.edit != 1}
                                                        />
                                                    </div>
                                                <p className="text-muted small mt-2">{t('survey.builder.bannerImageHelp')}</p>
                                                </div>
                                                <div className="action-wrap action-mob"></div>
                                            </div>

                                            <div className="form-field-wrapper d-flex button-wrap pt-md-4 mb-0 align-items-center">
                                                <button className='btn btn-primary me-2'>{submitData?.su_label_and_options ? (JSON.parse(submitData.su_label_and_options)[language_code] ?? t('survey.builder.submit')) : t('survey.builder.submit')}</button>
                                                <div className="action-wrap d-flex align-items-center mt-0">
                                                    <div className="action-buttons d-flex align-items-center">
                                                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title={t('survey.builder.edit1')} onClick={() => setSubmitModalOpen(true)}>
                                                            <Svg name="edit" />
                                                        </button>}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                        {/*
                                        <div className="opinion-scale d-flex align-items-center">
                                            <div className="select-language d-flex align-items-center">
                                                <label htmlFor="">Display form</label>
                                                <div className="dropdown table-dropdown ques-options">
                                                    <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <span className='me-2'>During survey</span>
                                                    </button>
                                                    <div className="dropdown-menu" aria-labelledby="languages">
                                                        <span className="dropdown-item">Before survey</span>
                                                        <span className="dropdown-item">During survey</span>
                                                        <span className="dropdown-item">Before report</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="question-number d-flex align-items-center">
                                                <label htmlFor="">Question number</label>
                                                < Input
                                                    type='text'
                                                    view='outlined'
                                                    dense={false}
                                                    color='default'
                                                    label=''
                                                    placeholder=''
                                                    success={false}
                                                    value={'5'}
                                                    error={false}
                                                    fill={true}
                                                    errorHelperText={null}
                                                    className={"choiceI"}
                                                />
                                            </div>
                                        </div> 
                                        */}


                                    </div>}

                                    {/*Form Preview Version*/}
                                    {mode === modes.preview && <div className="form-preview">
                                        <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center d-none">
                                            <div className="form-check form-check-inline ps-0">
                                                <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                                                <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline ps-0">
                                                <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                                                <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                                                    </svg>
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline ps-0">
                                                <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                                                <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                                                    </svg>
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline ps-0">
                                                <button className="full-screen-btn" title="View full screen">
                                                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                            </div>

                                        </div>
                                        <div className="title-wrap text-center">
                                            <h1>{heading ?? ''}</h1>
                                            <p>{description ?? ''}</p>
                                        </div>

                                        <div className="form-preview-inner">
                                            {
                                                leadGenData?.map((field, index) => {
                                                    return (
                                                        <CustomInputPreview
                                                            key={index}
                                                            data={field}
                                                            index={index}
                                                            language_code={language_code}
                                                        />
                                                    )
                                                })
                                            }

                                            <div className="mb__30">
                                                <div className="form-check">
                                                    <input type="checkbox" className="form-check-input" id="terms-check" disabled={window.modulePermissions.M12.edit != 1} />
                                                    <label className="form-check-label" htmlFor="terms-check" dangerouslySetInnerHTML={{ __html: TandCData?.su_label_and_options && (JSON.parse(TandCData.su_label_and_options)[language_code] ?? '') }} />
                                                </div>
                                            </div>
                                            <div className="button-wrap pt-4 mb-0 text-center" style={{ display: 'flex', justifyContent: submitPosition }}>
                                                <button className='btn btn-primary'>{submitData?.su_label_and_options ? (JSON.parse(submitData.su_label_and_options)[language_code] ?? t('survey.builder.submit')) : t('survey.builder.submit')}</button>
                                            </div>
                                            {privacyHeading && (
                                                <div className="desclaimer-text mt-3">
                                                    <p dangerouslySetInnerHTML={{ __html: privacyHeading }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteModal
                    currentlyDeletingField={currentlyDeletingField}
                    setCurrentlyDeletingField={setCurrentlyDeletingField}
                    handleDeleteField={handleDeleteField}
                />

                <EditSubmitBtnModal
                    modalOpen={submitModalOpen}
                    setModalOpen={setSubmitModalOpen}
                    data={submitData}
                    language_code={language_code}
                    survey_id={survey_id}
                />

                <EditTermAndConditionModal
                    modalOpen={TandCModalOpen}
                    setModalOpen={setTandCModalOpen}
                    data={TandCData}
                    language_code={language_code}
                    survey_id={survey_id}
                />

                <EditModal
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    data={modalData}
                    language_code={language_code}
                    survey_id={survey_id}
                />

            </div>
            <div className={`modal-backdrop fade ${modalOpen || TandCModalOpen || submitModalOpen ? 'show' : ''}`} style={{ display: `${modalOpen || TandCModalOpen || submitModalOpen ? 'block' : 'none'}` }}></div>
        </>
    )
}
